import { CmsMarketContractListDisplayType as DisplayType } from './cms-config.js';

export function resolveDisplayType(value, compact) {
  const type = typeof value === 'string' ? value.toLowerCase().trim() : '';
  return Object.values(DisplayType).includes(type)
    ? type
    : compact
      ? DisplayType.Compact
      : DisplayType.Classic;
}
